import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';

import moment from 'moment';
import { Font } from '@react-pdf/renderer'
import bold from "./fonts/Montserrat-Bold.ttf"
import regular from "./fonts/Montserrat-Regular.ttf"
import italic from "./fonts/Montserrat-Italic.ttf"
import Utils from "./../utils";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',
    fontFamily: 'regular',
    paddingBottom: 90
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  table: { paddingRight: 10, paddingLeft: 10, display: "table", width: "auto", borderStyle: "solid", borderWidth: 1, borderRightWidth: 0, borderBottomWidth: 0 }, 
  tableRow: { margin: "auto", flexDirection: "row" }, 
  tableCol: { width: "25%", borderStyle: "solid", borderWidth: 1, borderLeftWidth: 0, borderTopWidth: 1 }, 
  tableCell: { margin: "auto", marginTop: 5, fontSize: 10 },
  myTableCell: { width: '25%', margin: "auto" },
});

export default class PdfDocument extends React.Component {

    constructor(){
        super();
        this.event = undefined;

        Font.register({ family: "bold", fonts: [
            { src: bold, fontWeight: 100 },
          ]})    
          Font.register({ family: "regular", fonts: [
            { src: regular, fontWeight: 100 },
          ]})  
          Font.register({ family: "italic", fonts: [
            { src: italic, fontWeight: 100 },
          ]})  
        }

    async componentDidMount(){

        this.setState({});
    }

    render (){

        if (this.props.event == undefined) return  <Document />;
        
        const imgDataUrl = this.props.event.bannerImageUrl;
        const investorName = this.props.investor.name;
        const investorCompany = this.props.investor.company;

        const table = {padding: 10};
        const myTableHeader1 = {borderStyle: "solid", borderWidth: 0.5, fontFamily: 'bold', width: '30%', margin: "auto", textAlign: 'center', fontSize: 12, padding: 10};
        const myTableHeader2 = {borderStyle: "solid", borderWidth: 0.5, fontFamily: 'bold', width: '70%', margin: "auto", textAlign: 'center', fontSize: 12, padding: 10};
        const myTableCell1 = {width: '30%', height: '100%', lineHeight: '100%', borderStyle: "solid", borderWidth: 0.5, margin: "auto", textAlign: 'center', fontSize: 12, padding: 5};
        const myTableCell2 = {width: '70%', height: 'auto', borderStyle: "solid", borderWidth: 0.5, margin: "auto", textAlign: 'left', fontSize: 12, padding: 5};
        const subjectInfo = {width: '100%', fontSize: 12, marginTop: 10};
        const footerInfo = {maxHeight: 80, width: '100%', height: 'auto', fontSize: 12, padding: 10, marginBottom: 0, bottom: 20, position: 'absolute'};

        var filterMeetings = this.props.meetings.filter((elem) => Utils.checkInvestor(elem.investors, this.props.investor.id));        
        var filterBreaks = this.props.breaks.filter((elem) => elem.subject == this.props.investor.id);

        var startDate = this.props.event.startDate;
        var endDate = this.props.event.endDate;
        var infoSchedules = this.props.event.brokersInfoSchedulesEnabled;
    
        startDate = moment(startDate, "DD/MM/yyyy");
        endDate = moment(endDate, "DD/MM/yyyy");
    
        this.eventDays = [];
        var tempDate = startDate;
        while (tempDate <= endDate){
          this.eventDays.push(moment(tempDate));
          tempDate = tempDate.add(1, 'd');
        }

        return (
            <Document key={Math.random()} title={investorName + ' - ' + investorCompany} onRender={this.props.onRender ? this.props.onRender : null}>
                {this.eventDays.map(v => {

                    let date = moment(v).format('DD/MM/yyyy');
                    let dateComplete = moment(v).format('dddd, DD MMMM yyyy');

                    let filterMeetingsDate = filterMeetings.filter((elem) => elem.date == date);
                    let filterBreaksDate = filterBreaks.filter((elem) => elem.date == date);

                    let sortMeetings = filterMeetingsDate.sort((a, b) => {
                        var time1 = moment(a.date + " " + a.hour+":"+a.minutes, "DD/MM/yyyy HH:mm");
                        var time2 = moment(b.date + " " + b.hour+":"+b.minutes, "DD/MM/yyyy HH:mm");

                        return time1 - time2;
                    });

                    let sortBreaks = filterBreaksDate.sort((a, b) => {
                        var time1 = moment(a.date + " " + a.hour+":"+a.minutes, "DD/MM/yyyy HH:mm");
                        var time2 = moment(b.date + " " + b.hour+":"+b.minutes, "DD/MM/yyyy HH:mm");

                        return time1 - time2;
                    });

                    if (sortMeetings.length <= 0) return null;
                    
                    var pdfTitle = investorCompany + ' - ' + investorName;

                    return <Page key={Math.random()} wrap={false} size="A4" style={styles.page}>
                        <View style={table} key={Math.random()}>
                            <Image fixed style={{marginTop: 10, width: '100%', height: 'auto'}} src={imgDataUrl} />
                            <Text fixed style={{width: '100%', fontFamily: 'bold', fontSize: 13, marginTop: 5}} >{pdfTitle}</Text>
                            <Text fixed style={{width: '100%', fontFamily: 'bold', fontSize: 13, marginTop: 5}} >{dateComplete}</Text>

                            <View fixed style={{marginTop: 10, flexDirection: 'row'}} >
                                <Text style={myTableHeader1} >Time {' ' + this.props.event.timezoneInformation}</Text>
                                <Text style={myTableHeader2} >Meeting</Text>
                            </View>

                            {
                                    Utils.getHoursArray().map(hh => {
                                        return Utils.getMinutesArray().map(mm => {

                                            var elemToReturn = <View />;
                                            sortBreaks.forEach(b => {
                                                if (b.break_type == 'Unavailable') return <View />;
                                                if (b.minutes != mm || b.hour != hh) return <View />;
                                                let breakTime = moment(parseInt(b.hour)+":"+parseInt(b.minutes), "hh:mm");
                                                let breakEndTime = moment(breakTime).add(b.slots * 5, 'minutes');
            
                                                let strTime = moment(breakTime).format("HH:mm");
                                                let strEndTime = moment(breakEndTime).format("HH:mm");
            
                                                elemToReturn = <View key={Math.random()} wrap={false} style={{flexDirection: 'row'}} > 
                                                            <Text style={myTableCell1} >{strTime + ' - ' + strEndTime}</Text>
                                                            <Text style={myTableCell2} >{b.break_type}</Text>
                                                        </View>;
                                            })

                                            sortMeetings.forEach(m => {
                                                if (m.minutes != mm || m.hour != hh) return <View />;
                                                let meetingTime = moment(parseInt(m.hour)+":"+parseInt(m.minutes), "hh:mm");
                                                let meetingEndTime = moment(meetingTime).add(m.slots * 5, 'minutes');
                
                                                let strTime = moment(meetingTime).format("HH:mm");
                                                let strEndTime = moment(meetingEndTime).format("HH:mm");
                
                                                var companiesList = [];
                                                m.investors.map(inv => {
                                                    if (inv.isAnalyst == 0 && companiesList.indexOf(inv.company) == -1)
                                                        companiesList.push(inv.company);
                                                });
                
                                                var meetingDesc = [];
                                                if (companiesList.length == 0) meetingDesc += "Analysts Meeting with: \n";
                                                else if (companiesList.length == 1) meetingDesc.push("1 to 1 Meeting with ");
                                                else if (companiesList.length < 5) meetingDesc.push("1 to Few Meeting with ");
                                                else meetingDesc.push("Group Meeting with ");
                
                                                meetingDesc.push(<Text key={Math.random()} style={{fontFamily: 'bold', fontWeight: 100}}>{m.c_name}</Text>);
                                                if (infoSchedules == 1) 
                                                    meetingDesc.push(' (hosted by ' + m.brokerCompany+ ')');
                                                    
                                                const rapresentativeArray = m.rapresentative.split(';');
                                                const exceludedRapresentativeArray = m.excludedRapresentatives.split(';');
                                                if (rapresentativeArray.length > 0) {
                                                    meetingDesc.push(" - ");
                                                    rapresentativeArray.map(r => {
                                                        if (exceludedRapresentativeArray.indexOf(r) == -1 )
                                                            meetingDesc.push(r + "; ");
                                                    });
                                                }
                
                                                
                                                elemToReturn = <View key={Math.random()} wrap={false} style={{flexDirection: 'row'}} > 
                                                            <Text style={myTableCell1} >{strTime + ' - ' + strEndTime}</Text>
                                                            <Text style={myTableCell2} >{meetingDesc.map(d => d)} <Text style={{fontFamily: 'italic'}}>{m.notes.trim() != '' ? "\n\n" + m.notes : ''}</Text></Text>
                                                        </View>;
                                            })

                                            return elemToReturn;

                                        })
                                    })
                                }


                            
                        <View style={subjectInfo} >
                            <Text >{this.props.investor.notes}</Text>
                        </View>
                        </View>
                        <View fixed style={footerInfo} >
                            <Text  >{this.props.event.notes}</Text>
                        </View>
                    </Page> })
                }
                
            </Document>
        );
    }

}
